import { render, staticRenderFns } from "./GradingScaleTypes.vue?vue&type=template&id=32b6a804&"
import script from "./GradingScaleTypes.vue?vue&type=script&lang=js&"
export * from "./GradingScaleTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports